module.exports = __webpack_public_path__ + "img/avatar-block.b20a3f74.jpg";